import { injectable, injectFromBase } from 'inversify'
import { DomainSettings } from '@/decorators/domainDecorators'
import DomainBaseService from '@/services/domain/domainBaseService'
import BonusInfo from '@/data/models/domain/BonusInfo'
import type BonusInfoRepository from '@/data/repositories/domain/bonusInfoRepository'

@DomainSettings({
  model: BonusInfo,
})
@injectable()
@injectFromBase()
export default class BonusInfoService extends DomainBaseService<BonusInfoRepository> {
  public readonly quantityBonusEmails = 10_000

  public readonly quantityBonusEmailLookups = 10_000

  public fillInfoBonus() {
    return this.getDomainRepository().fillBonusInfo()
  }

  public async updateBonusInfo(info: Pick<BonusInfo, 'emails' | 'emailLookups' | 'emailStatus'>) {
    return this.getDomainRepository().updateBonusInfo(info)
  }

  public findBonusInfoOrNull() {
    return this.getDomainRepository().findBonusInfoOrNull()
  }
}
